var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lp-check-container"},[_c('div',{staticClass:"sel-btn",class:{'selected': _vm.selected === _vm.val },on:{"click":_vm.clickCheck}},[(_vm.selected===_vm.val)?_c('i',{staticClass:"material-icons checked-icon"},[_vm._v("check")]):_vm._e()]),_c('div',{staticClass:"lp-label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }